import { mapActions } from 'vuex';
import Events from '_utils/events';
import CommercialService from '_services/rest/modules/commercial';
import { _DELETE_COMMERCIAL_ } from './CommercialModel';

export default {
  name: 'commercial-actions',
  data() {
    return {
      selectCommercial: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      CommercialService.deleteCommercial(this.selectCommercial)
        .then(() => {
          this.close();
          this.$router.push('/admin/comercial/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Membro deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_DELETE_COMMERCIAL_, commercial => {
      this.selectCommercial = commercial.id;
    });
  },
};
